// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"143":"fail","208":"success","240":"support","779":"error","962":"home"}[chunkId] + "." + {"143":"bfc44d07","208":"277a244f","240":"5586a383","779":"84cc741c","962":"55034395"}[chunkId] + ".js";
};